import en from "./en.json";
import fi from "./fi.json";

const messages = { fi, en };

export default messages;